import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleContainerDirective } from 'src/app/modules/directives/module-container.directive';
import { map, Observable } from 'rxjs';
import { ProductDTO } from '../../models/product-dto';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reagents-detail-page',
  standalone: true,
  imports: [CommonModule, ModuleContainerDirective],
  templateUrl: './reagents-detail-page.component.html',
  styleUrl: './reagents-detail-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReagentsDetailPageComponent {
  @Input({ required: true }) public slug!: string;
  private readonly route = inject(ActivatedRoute);
  public readonly data$: Observable<ProductDTO> = this.route.data.pipe(
    map(d => d['data'] as ProductDTO),
  );
}
